import { ProgressBar, Step } from "react-step-progress-bar";
import "./MultiStepProgressBar.css";

const MultiStepProgressBar = ({ page, onPageNumberClick }) => {
  var stepPercentage = 0;
  if (page === "kundensuche") {
    stepPercentage = 10;
  } else if (page === "info") {
    stepPercentage = 30;
  } else if (page === "leistung") {
    stepPercentage = 50;
  } else if (page === "summary") {
    stepPercentage = 70;
  } else if (page === "checkpage") {
    stepPercentage = 90;
  } else if (page === "finalpage") {
    stepPercentage = 100;
  }

  return (
    <ProgressBar percent={stepPercentage}>
      {[1, 2, 3, 4, 5, 6].map((stepNumber) => (
        <Step key={stepNumber}>
          {({ accomplished, index }) => {
            const style = accomplished
              ? "sm:w-12 w-8 sm:h-12 h-8 text-sm bg-blue_royal rounded-full border-2 border-blue-royal flex justify-center items-center text-white"
              : "sm:w-12 w-8 sm:h-12 h-8 text-sm bg-white rounded-full border-2 border-gray-300 flex justify-center items-center text-gray-400";

            return (
              <div
                className={style}
                onClick={() => onPageNumberClick(stepNumber.toString())}
              >
                {index + 1}
              </div>
            );
          }}
        </Step>
      ))}
    </ProgressBar>
  );
};

export default MultiStepProgressBar;
